<template>
    <div v-if="user">
      <div class="common-header-wrap">
        <mt-header :title="(user.organization_type?'企业':'个人')+'认证'" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
	  <div class='main-content'>
		  <div @click="qualityVisible=true"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">资质证书</span></flex-line></div>
		  <div @click="sceneVisible=true"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">工作实景</span></flex-line></div>
	  </div>

      <!--资质证书-->
      <mt-popup v-model="qualityVisible" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="资质证书" class="common-header">
            <mt-button slot="left" icon="back" @click="qualityVisible=false"></mt-button>
            <mt-button class="upload-btn" slot="right"><div @change="uploadImage('quality',$event)">上传<input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg"></div></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <ul class="upload-list" v-if="qualityList">
            <li class="upload-item" v-for="item in qualityList" :key="item.o2o_fuwu_upload_id">
              <div class="img-wraper">
                <img :src="item.o2o_fuwu_upload_url_url">
              </div>
              <i class="iconfont" @click="delInfoFile(item.o2o_fuwu_upload_id,'quality')">&#xe69a;</i>
            </li>
          </ul>
        </div>
      </mt-popup>

      <!--工作实景-->
      <mt-popup v-model="sceneVisible" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="工作实景" class="common-header">
            <mt-button slot="left" icon="back" @click="sceneVisible=false"></mt-button>
            <mt-button class="upload-btn" slot="right"><div @change="uploadImage('scene',$event)">上传<input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg"></div></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <ul class="upload-list" v-if="sceneList">
            <li class="upload-item" v-for="item in sceneList" :key="item.o2o_fuwu_upload_id">
              <div class="img-wraper">
                <img :src="item.o2o_fuwu_upload_url_url">
              </div>
              <i class="iconfont" @click="delInfoFile(item.o2o_fuwu_upload_id,'scene')">&#xe69a;</i>
            </li>
          </ul>
        </div>
      </mt-popup>
    </div>
</template>

<script>

import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { getInfoFileList, uploadInfoFile, delInfoFile } from '../../../api/fuwuManageInfo'
import flexLine from '../../flexLine'
export default {
  components: {
	  flexLine
  },
  name: 'FuwuManageAuthen',
  data () {
    return {
      qualityVisible: false,
      sceneVisible: false,
      qualityList: false,
      sceneList: false
    }
  },
  mounted () {

  },
  computed: {
    ...mapState({
      user: state => state.fuwu.info
    })
  },
  created: function () {
    this.getInfoFileList('quality')
    this.getInfoFileList('scene')
  },

  methods: {

    delInfoFile (id, type) {
      delInfoFile(id).then(res => {
        // 重新获取图片
        this.getInfoFileList(type)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getInfoFileList (type) {
      getInfoFileList(type).then(res => {
        if (type == 'quality') {
          this.qualityList = res.result.file_list
        } else {
          this.sceneList = res.result.file_list
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    uploadImage (type, event) {
      if (typeof (event.target.files[0]) === 'undefined') {
        return
      }
      let formdata = new FormData()

      formdata.append('file', event.target.files[0])
      formdata.append('type', type)
      uploadInfoFile(formdata).then(res => {
        // 重新获取图片
        this.getInfoFileList(type)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
.main-content{background: #fff;padding:0 $pageSpace}
.upload-list{padding:.5rem;overflow:hidden;
  .upload-item{width:50%;height:0;padding-bottom:50%;box-sizing:border-box;position:relative;text-align: center;float:left;
    .img-wraper{position:absolute;bottom:.25rem;top:.25rem;left:.25rem;right:.25rem;border:1px solid #e1e1e1;display: flex;;align-items: center;
      img{max-width:100%;max-height: 100%;margin: 0 auto;}
    }
    i{position:absolute;top:.25rem;right:.25rem;}
  }
}
.upload-btn{position:relative;
  input{position:absolute;top:0;right:0;bottom:0;left:0;opacity: 0}
}
</style>
